module.exports = __webpack_public_path__ + "img/laura-610f7ab.jpg";